

// ALL_VALUES is id for 'All ...' option because custom fields may contain null value then it can't be used as "All' option value
import FieldProto from "../../fields3/proto/field-proto";

export const QUICK_FILTER_ALL_VALUES        = 'all_values';

export type QuickFilterSettings = {

    field           : FieldProto
    value           : any

    filterOptions   : any[]

}

export type QuickFilterField = {

    id              : string
    label           : string
}